import { Task } from "gantt-task-react";
import React, { useRef } from "react";
import "./GanttRender.css";

interface ExtendedTask extends Task {
    taskId?: number;
}

const CustomTooltip: React.FC<{ task: ExtendedTask }> = ({ task }) => {
    const formatDate = (date: Date): string => {
        return `${String(date.getDate()).padStart(2, "0")}.${String(date.getMonth() + 1).padStart(
            2,
            "0"
        )}.${date.getFullYear()}`;
    };

   
    return (
        <div
            className="gant_render--tooltip" // Корректируем позицию при появлении
        >
            <div className="gant_render--tooltipContent">
                <div>
                    <strong className="gant_render--tooltipStrong">Название:</strong> {task.name}
                </div>
                <div>
                    <strong className="gant_render--tooltipStrong">Дата начала:</strong> {formatDate(task.start)}
                </div>
                <div>
                    <strong className="gant_render--tooltipStrong">Дата окончания:</strong> {formatDate(task.end)}
                </div>
                <div>
                    <strong className="gant_render--tooltipStrong">Прогресс:</strong> {task.progress}%
                </div>
            </div>
        </div>
    );
};

export default CustomTooltip;
